// extracted by mini-css-extract-plugin
module.exports = {"theme":"#0256ff"};
    if(module.hot) {
      // 1788499932447
      var cssReload = require("D:/gitee/宠物升级/mer_plat_admin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  